import { RootState } from '../store';
import { IReqProps, regionApi, regionRequest } from './regionApi';

/* -------------------------------------------------- */

export const regionSnapshotApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    /* ================================================== */
    /* Snapshot list                                      */
    /* ================================================== */
    getSnapshotList: build.query<any, Record<string, any>>({
      query: ({ account }) =>
        regionRequest(account?.region, 'instance/snapshot_list', {
          method: 'POST',
          body: {
            account_id: account?.account_id
          }
        }),

      transformResponse: (result, _meta, arg) => ({
        account_id: arg.account?.account_id,
        data: result
      })
    }),

    /* ================================================== */
    /* Create snapshot                                    */
    /* ================================================== */
    createSnapShot: build.mutation<any, IReqProps>({
      async queryFn(arg, api, _extra, fetchWithBQ) {
        const state = api.getState() as RootState;

        const region = state.auth.regions?.[arg?.region || ''];

        if (!region) {
          return {
            error: {
              status: 500,
              statusText: 'Internal RTK Query Error',
              data: 'Region token or url not exist!'
            }
          };
        }

        return fetchWithBQ(
          regionRequest(region, 'instance/create_snapshot', {
            method: 'POST',
            body: {
              account_id: arg?.accountIds?.[0] || '',
              snapshot_name: arg?.snapShotName || '',
              desc: arg?.snapShotDesc || ''
            }
          })
        );
      }
    }),

    /* ================================================== */
    /* Revert snapshot                                    */
    /* ================================================== */
    revertSnapShot: build.mutation<any, IReqProps>({
      async queryFn(arg, api, _extra, fetchWithBQ) {
        const state = api.getState() as RootState;

        const region = state.auth.regions?.[arg?.region || ''];

        if (!region) {
          return {
            error: {
              status: 500,
              statusText: 'Internal RTK Query Error',
              data: 'Region token or url not exist!'
            }
          };
        }

        return fetchWithBQ(
          regionRequest(region, 'instance/revert_snapshot', {
            method: 'POST',
            body: {
              account_id: arg?.accountIds?.[0] || '',
              snapshot_id: arg?.snapShotId || ''
            }
          })
        );
      }
    })

    /* -------------------------------------------------- */
  }),

  overrideExisting: false
});

/* -------------------------------------------------- */

export const {
  useGetSnapshotListQuery,
  useLazyGetSnapshotListQuery,
  useCreateSnapShotMutation,
  useRevertSnapShotMutation
} = regionSnapshotApi;
